<template>
  <div @click="isShow = false" v-show="isShow" class="Bigbox">
    <div class="contentBox" @click.stop>
      <slot name="default"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SafeBox',
  data () {
    return {
      isShow: false,
    }
  }
}
</script>
<style lang="less" scoped>
.Bigbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .flexColumnAround();
}
.contentBox{
  width: 100%;
  height: 80%;
}
</style>